<template>
  <div class="page 401-page">
    <div class="page-header">
      <h1>401 Forbidden</h1>
    </div>
    <p>You are not authorized to access the page you requested.</p>
    <div>
      <a class="btn btn-light" @click="logout()">Log out</a>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      async logout() {
        await this.$auth.logout("/");
      }
    }
  };
</script>